import { render, staticRenderFns } from "./BpbDetail.vue?vue&type=template&id=5c525b41&"
import script from "./BpbDetail.vue?vue&type=script&lang=js&"
export * from "./BpbDetail.vue?vue&type=script&lang=js&"
import style0 from "./BpbDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports